import NotFound from 'components/shared/NotFound';
import React from 'react';
import { Route, Routes } from 'react-router-dom-v5-compat';
import ForgotPassword from './Forgot';
import ResetPassword from './Reset';

function Password() {
  return (
    <Routes>
      <Route path="forgot" element={<ForgotPassword />} />
      <Route path="reset" element={<ResetPassword />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Password;
